export default __webpack_public_path__ + "0975d6efffdd50432090a4e83720f9de.svg";